export default __webpack_public_path__ + "static/media/reims4.35a64c8b.jpg";